
$( document ).ready(function() {


var vehicleType;
var url;
var makeChosen;
var modelChosen;
var fuelChosen;
var yearChosen;

  $(".battery-select").chosen({

    // config items
    width: "22.5%",
    allow_single_deselect: false,
    inherit_select_classes: true

  });

  

   $("select.vehicle").chosen().change(function() {

      vehicleType = $(this).val();

      // if car chosen show the fuel dropdown
      if(vehicleType == "car"){
        $(".chosen-container.fuel").show();
      }else{
        $(".chosen-container.fuel").hide();
      }


      if(vehicleType == "product"){
          
          // need to clear model and year choices
          $('select.make, select.model, select.fuel, select.year').val('');
          $('select.make, select.model, select.fuel, select.year').empty(); //remove all child nodes
          
          var newOption = $('<option value=""></option>');
          $('select.make, select.model, select.fuel, select.year').append(newOption);
          $('select.make, select.model, select.fuel, select.year').prop("disabled", true);
          $('select.make, select.model, select.fuel, select.year').trigger('chosen:updated');

          // hide any search results
          $(".results").empty();

          // hide the dropdowns
          $(".dropdown-wrap").hide();
          $(".standard-search-field").removeClass("hide");

      }else{

          // show the dropdowns (just in case they are hidden)
          $(".dropdown-wrap").show();
          $(".standard-search-field").addClass("hide");
      }


      // determine lookup url
      switch(vehicleType) {
        case "motorbike":
          url = "https://filters.batteryworld.ie/filter/motorbike/get_list.php?action=brands";
          break;
        
        case "car":
          url = "https://filters.batteryworld.ie/filter/car/get_list.php?action=make";
          break;

        case "atv":
          url = "https://filters.batteryworld.ie/filter/atv/get_list.php?action=brands";
          break;

        case "garden":
          url = "https://filters.batteryworld.ie/filter/garden/get_list.php?action=brands";
          break;

        case "watercraft":
          url = "https://filters.batteryworld.ie/filter/watercraft/get_list.php?action=brands";
          break;

        case "utility":
          url = "https://filters.batteryworld.ie/filter/utility/get_list.php?action=brands";
          break;

        default:
          url = "";
          break;

        }


        if(url != ""){


            // need to clear model and year choices
            $('select.make, select.model, select.fuel, select.year').val('');
            $('select.make, select.model, select.fuel, select.year').empty(); //remove all child nodes
            
            var newOption = $('<option value=""></option>');
            $('select.make, select.model, select.fuel, select.year').append(newOption);
            $('select.make, select.model, select.fuel, select.year').prop("disabled", true);
            $('select.make, select.model, select.fuel, select.year').trigger('chosen:updated');



          $.ajax({
            dataType: "json",
            url: url,
            success: function( data ){

              $.each(data, function(key, value) {
                $('select.make')
                .append($("<option></option>")
                  .attr("value",key)
                  .text(value));
              });

              $('.battery-select.make').prop("disabled", false);
              $(".battery-select.make").trigger("chosen:updated");


            },
            error: function(){

              console.log("Error retrieving list of makes");

            }
          });

      }

   });




   $("select.make").chosen().change(function() {


      makeChosen = $("select.make").val();
 

      // determine lookup url
      switch(vehicleType) {
        case "motorbike":
          url = "https://filters.batteryworld.ie/filter/motorbike/get_list.php?action=models&brandChosen="+makeChosen;
          break;
        
        case "car":
          url = "https://filters.batteryworld.ie/filter/car/get_list.php?action=models&makeChosen="+makeChosen;
          break;

        case "atv":
          url = "https://filters.batteryworld.ie/filter/atv/get_list.php?action=models&brandChosen="+makeChosen;
          break;

        case "garden":
          url = "https://filters.batteryworld.ie/filter/garden/get_list.php?action=models&brandChosen="+makeChosen;
          break;

        case "watercraft":
          url = "https://filters.batteryworld.ie/filter/watercraft/get_list.php?action=models&brandChosen="+makeChosen;
          break;

        case "utility":
          url = "https://filters.batteryworld.ie/filter/utility/get_list.php?action=models&brandChosen="+makeChosen;
          break;
        }

         // need to clear model and year choices
         $('select.model, select.fuel, select.year').val('');
         $('select.model, select.fuel, select.year').empty(); //remove all child nodes

         var newOption = $('<option value=""></option>');
         $('select.model, select.fuel, select.year').append(newOption);
         $('select.model, select.fuel, select.year').prop("disabled", true);
         $('select.model, select.fuel, select.year').trigger('chosen:updated');


         $.ajax({
          dataType: "json",
          url: url,
          success: function( data ){

            $.each(data, function(key, value) {
              $('select.model')
              .append($("<option></option>")
                .attr("value",key)
                .text(value));
            });

            $('.battery-select.model').prop("disabled", false);
            $(".battery-select.model").trigger("chosen:updated");


          },
          error: function(){

            console.log("Error retrieving list of models");

          }
        });

   });



   $("select.model").chosen().change(function() {


      makeChosen = $("select.make").val();
      modelChosen = $("select.model").val();
 

      // determine lookup url
      switch(vehicleType) {
        case "motorbike":
          url = "https://filters.batteryworld.ie/filter/motorbike/get_list.php?action=year&brandChosen="+makeChosen+"&modelChosen="+modelChosen;
          break;
        
        case "car":
          url = "https://filters.batteryworld.ie/filter/car/get_list.php?action=fuel&makeChosen="+makeChosen+"&modelChosen="+modelChosen;
          break;

        case "atv":
          url = "https://filters.batteryworld.ie/filter/atv/get_list.php?action=year&brandChosen="+makeChosen+"&modelChosen="+modelChosen;
          break;

        case "garden":
          url = "https://filters.batteryworld.ie/filter/garden/get_list.php?action=year&brandChosen="+makeChosen+"&modelChosen="+modelChosen;
          break;

        case "watercraft":
          url = "https://filters.batteryworld.ie/filter/watercraft/get_list.php?action=year&brandChosen="+makeChosen+"&modelChosen="+modelChosen;
          break;

        case "utility":
          url = "https://filters.batteryworld.ie/filter/utility/get_list.php?action=models&brandChosen="+makeChosen;
          break;
        }

         // need to clear model and year choices
         $('select.fuel, select.year').val('');
         $('select.fuel, select.year').empty(); //remove all child nodes

         var newOption = $('<option value=""></option>');
         $('select.fuel, select.year').append(newOption);
         $('select.fuel, select.year').prop("disabled", true);
         $('select.fuel, select.year').trigger('chosen:updated');


         $.ajax({
          dataType: "json",
          url: url,
          success: function( data ){

            if(vehicleType == "car"){

              $.each(data, function(key, value) {
                $('select.fuel')
                .append($("<option></option>")
                  .attr("value",key)
                  .text(value));
              });

              $('.battery-select.fuel').prop("disabled", false);
              $(".battery-select.fuel").trigger("chosen:updated");

            }else{

               $.each(data, function(key, value) {
                $('select.year')
                .append($("<option></option>")
                  .attr("value",key)
                  .text(value));
              });

              $('.battery-select.year').prop("disabled", false);
              $(".battery-select.year").trigger("chosen:updated");

            }


          },
          error: function(){

            console.log("Error retrieving list of years");

          }
        });

   });



    $("select.fuel").chosen().change(function() {


      makeChosen = $("select.make").val();
      modelChosen = $("select.model").val();
      fuelChosen = $("select.fuel").val();
 

      

         // need to clear model and year choices
         $('select.year').val('');
         $('select.year').empty(); //remove all child nodes

         var newOption = $('<option value=""></option>');
         $('select.year').append(newOption);
         $('select.year').prop("disabled", true);
         $('select.year').trigger('chosen:updated');


         $.ajax({
          dataType: "json",
          url: "https://filters.batteryworld.ie/filter/car/get_list.php?action=years&makeChosen="+makeChosen+"&modelChosen="+modelChosen+"&fuelChosen="+fuelChosen,
          success: function( data ){

            $.each(data, function(key, value) {
              $('select.year')
              .append($("<option></option>")
                .attr("value",key)
                .text(value));
            });

            $('.battery-select.year').prop("disabled", false);
            $(".battery-select.year").trigger("chosen:updated");


          },
          error: function(){

            console.log("Error retrieving list of years");

          }
        });

   });



   $("select.year").chosen().change(function() {


      makeChosen = $("select.make").val();
      modelChosen = $("select.model").val();
      fuelChosen = $("select.fuel").val();
      yearChosen = $("select.year").val();
 

      // determine lookup url
      switch(vehicleType) {
        case "motorbike":
          url = "https://filters.batteryworld.ie/filter/motorbike/get_battery.php?brandChosen="+makeChosen+"&modelChosen="+modelChosen+"&yearChosen="+yearChosen;
          break;
        
        case "car":
          url = "https://filters.batteryworld.ie/filter/car/get_battery.php?makeChosen="+makeChosen+"&modelChosen="+modelChosen+"&fuelChosen="+fuelChosen+"&yearChosen="+yearChosen
          break;

        case "atv":
          url = "https://filters.batteryworld.ie/filter/atv/get_battery.php?brandChosen="+makeChosen+"&modelChosen="+modelChosen+"&yearChosen="+yearChosen;
          break;

        case "garden":
          url = "https://filters.batteryworld.ie/filter/garden/get_battery.php?brandChosen="+makeChosen+"&modelChosen="+modelChosen+"&yearChosen="+yearChosen;
          break;

        case "watercraft":
          url = "https://filters.batteryworld.ie/filter/watercraft/get_battery.php?brandChosen="+makeChosen+"&modelChosen="+modelChosen+"&yearChosen="+yearChosen;
          break;

        case "utility":
          url = "https://filters.batteryworld.ie/filter/utility/get_battery.php?brandChosen="+makeChosen+"&modelChosen="+modelChosen+"&yearChosen="+yearChosen;
          break;
        }

        
         $.ajax({
        dataType: "text",
        url: url,
        success: function( data ){
          
           $( ".results" ).html( data );
           $( ".results-notice" ).show();

        },
        error: function(){

          alert("Error retrieving battery");

        }
      });

   });




});